import { FC, FormEventHandler } from 'react';
import { Control } from 'react-hook-form';
import { Button } from 'atoms/Button';
import { TextInput } from 'organisms/TextInput';
import styles from './styles.module.css';

export const NewsletterForm: FC<{
  handleSubscribe: FormEventHandler<HTMLFormElement>;
  control: Control;
  placeholder: string;
  button_text: string;
  centered?: boolean;
  inputClassName?: string;
}> = ({
  handleSubscribe,
  control,
  placeholder,
  button_text,
  centered,
  inputClassName,
}) => {
  return (
    // name attribute needs for correct getting form in test
    <form onSubmit={handleSubscribe} className={styles.root} name="newsletter">
      <TextInput
        name="email"
        control={control}
        placeholder={placeholder}
        centered={centered}
        inputClassName={inputClassName}
      />
      <Button type="submit" className={styles.button}>
        {button_text}
      </Button>
    </form>
  );
};
